import { createCommonjsModule, unwrapExports } from '../../../../_virtual/_commonjsHelpers.es.js';

var assertThisInitialized = createCommonjsModule(function (module) {
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
const _assertThisInitialized = unwrapExports(assertThisInitialized);

export { assertThisInitialized as __moduleExports, _assertThisInitialized as default };
